// extracted by mini-css-extract-plugin
export default {"users":"users_users__hG+Tx"};